<template>
  <div class="col-md-3">
    <label :for="id">{{ this.$t(labelName) }}</label>
    <select
      :id="id"
      class="form-control"
      v-model="selectedObject"
      @change="changeSelectedOption"
    >
      <option value="">{{ this.$t(defaultOptionName) }}</option>
      <option
        v-for="DropdownOption in showOnlyValidData"
        :key="'Dropdown' + DropdownOption"
        :value="DropdownOption"
      >
        {{ getTranslationForDropdownOption(DropdownOption) }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'DropdownWithValidData',
  props: {
    id: {
      type: String,
      required: true
    },
    labelName: {
      type: String,
      required: true
    },
    defaultOptionName: {
      type: String,
      required: true
    },
    dropdownOptions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
        selectedObject: '',
    }
  },
  methods: {
    changeSelectedOption() {
      this.$emit('changeSelectedOption', this.selectedObject);
    },
    getTranslationForDropdownOption(dropdownOption) {
      let resultString = 'system_event.objects_in_filters_and_table.';
      if(!this.id || !dropdownOption) {
        return undefined;
      }
      resultString += this.id +'.';
      resultString += dropdownOption;
      const translation = this.$t(resultString);
      if(translation == resultString) {
        return undefined;
      }
      return translation;
    }
  },
  computed: {
    showOnlyValidData() {
      if(!Array.isArray(this.dropdownOptions)) return [];
      return this.dropdownOptions.filter(element => this.getTranslationForDropdownOption(element));
    }
  }
};
</script>